import MasterShopFaceRegistrationFormV1 from './MasterShopFaceRegistrationFormV1';

export default MasterShopFaceRegistrationFormV1;
